module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', _vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '项目' + (index + 1)
      },
      on: {
        "click": function($event) {
          return _vm.downloadCert(subject, {})
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [(subject.have_cert) ? _c('div', {
            staticClass: "tiny-btn-1"
          }, [_vm._v("下载证书")]) : _c('div', {
            staticClass: "tiny-btn-0"
          }, [_vm._v("暂无成绩")])]
        },
        proxy: true
      }, {
        key: "label",
        fn: function() {
          return [_c('div', [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), _c('div', {
            staticStyle: {
              "word-break": "normal"
            }
          }, [_vm._v("\n                    运动员:\n                    "), _vm._l((subject.yundongyuan), function(member, index) {
            return _c('span', {
              key: index,
              staticStyle: {
                "color": "#111",
                "font-size": "14px",
                "padding": "6px",
                "white-space": "nowrap",
                "display": "inline-block"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.downloadCert(subject, member)
                }
              }
            }, [_vm._v(_vm._s(member.name) + " ")])
          })], 2)]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showCert),
      callback: function($$v) {
        _vm.showCert = $$v
      },
      expression: "showCert"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "选择证书"
    },
    model: {
      value: (_vm.showSelect),
      callback: function($$v) {
        _vm.showSelect = $$v
      },
      expression: "showSelect"
    }
  }, [_c('van-cell-group', [(_vm.row.shequ_cert_url) ? _c('van-cell', {
    attrs: {
      "title": "社区运动会优秀组织单位证书",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.getShequYouxiuCert()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "全国证书",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.shequDownload('')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "省级证书",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.shequDownload('province')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "市级证书",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.shequDownload('city')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('NavFloatShare', {
    on: {
      "show": function($event) {
        _vm.show_share_panel = true
      }
    }
  }), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.overlayShow,
      "lock-scroll": ""
    },
    on: {
      "click": function($event) {
        return _vm.timeChange(1)
      }
    }
  }), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": function($event) {
        _vm.showWxShare = false
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89f0a2c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiCertList.vue
// module id = 2541
// module chunks = 0